export default {
  SET_PURL_ID(state, purlId) {
    state.id = purlId;
  },
  SET_PURL_INFO(state, purlInfo) {
    state.info = purlInfo;
	state.dataLoaded = true;
  },
};
